import React, { useEffect, useState } from 'react'
import OperatorDropdown from './operatordropdown';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import { useSelector } from 'react-redux';
import { selectors as headerSelector } from "../../../state/features/header";
import { REGION } from '../../../const/linksection';

const DateTimeFilter = (props:any) => {
    const { firstFilterProps } = props;
  const { headercurrentuser }: any = useSelector((state) => ({
    headercurrentuser: headerSelector.currentuser(state),
  }));

  const getDTFormat = (defaultFormat: any) => {
    const defaultFormatConst = defaultFormat ? defaultFormat?.toLowerCase() : "";
    if (defaultFormatConst == "dd-mmm-yyyy")
      return "dd-MMM-yyyy HH:mm:ss";
    else if (defaultFormatConst == "mm/dd/yyyy")
      return "MM/dd/yyyy HH:mm:ss";
    else
      return defaultFormat + ' HH:mm:ss';
  }

  const fetchFormat = () => {
    const defaultFormatConst = headercurrentuser?.defaultDateFormat ? headercurrentuser?.defaultDateFormat?.toLowerCase() : "";
    if (defaultFormatConst == "dd-mmm-yyyy") {
      return (defaultFormatConst) ? getDTFormat(defaultFormatConst) : 'dd-MMM-yyyy HH:mm:ss';
    } else {
      return (headercurrentuser?.userpreference?.culture != '' && headercurrentuser?.userpreference?.culture != "en_us" && headercurrentuser?.userpreference?.culture != "en_ca") ? 'dd/MM/yyyy HH:mm:ss' : 'MM/dd/yyyy HH:mm:ss';
    }
  }

  const [currentOperator, setCurrentOperator] = useState({
        text: 'Is equal to',
        operator: 'eq',
      });
      let customOperators = [
        {
          text: 'Is equal to',
          operator: 'eq',
        },
        {
          text: 'Is after',
          operator: 'gt',
        },
        {
          text: 'Is before',
          operator: 'lt',
        }
      ];
      let operator = firstFilterProps.operator;

      const value = firstFilterProps.value || null;
      
      useEffect(() => {
        if (firstFilterProps.operator) {
          let newOperator = customOperators.filter(
            (item) => item.operator === firstFilterProps?.operator
          );
          if (newOperator?.length > 0) {
            operator = newOperator[0];
          } else {
            operator = {
              text: 'Is equal to',
              operator: 'eq',
            };
          }
        }
        setCurrentOperator(operator);
      }, [operator]);

      const operatorClick = (ev: any) => {
        let newOperator = ev.value.operator;
        firstFilterProps?.onChange({
          value: undefined,
          operator: newOperator,
          syntheticEvent: ev.syntheticEvent,
        });
        setCurrentOperator(ev.value);
      };
      const onDateChange = (event: any) => {
        firstFilterProps?.onChange({
          value: event?.value ? event?.value : undefined,
          operator: currentOperator?.operator,
          syntheticEvent: event.syntheticEvent,
        });
      };
        return (
          <div className="custom-filter-ui">
            <OperatorDropdown
              currentOperator={currentOperator}
              customOperators={customOperators}
              operatorClick={operatorClick}
            />
            <DateTimePicker
              value={value ? value : undefined}
              format={fetchFormat()}
              placeholder={fetchFormat()}
              onChange={onDateChange}
              formatPlaceholder={{
                year: 'yyyy',
                month: 'MM',
                day: 'dd',
                hour: 'HH',
                minute: 'mm',
                second: 'ss'
              }}
            />
          </div>
        );
}

export default DateTimeFilter